import PropTypes from "prop-types";
import React, { forwardRef } from "react";

// @mui
import { Link, Box, Chip } from "@mui/material";
import { useProductFeatures } from "@/hooks/useProductFeatures";
import { APP_VERSION } from "../../utils/constants";
import HNLNavLogo from "@/assets/images/common/hnl-header-logo.svg";

// routes
import { RouterLink } from "@/routes/components";
import { useCurrentUser } from "@/hooks/useCurrentUser";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, ...other }, ref) => {
  const { msPlans } = useProductFeatures();
  const currentUser = useCurrentUser();

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: "75%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        mt: 1,
        mb: 2,
      }}
      {...other}
    >
      <Box sx={{ width: "90%", display: "flex", justifyContent: "flex-end" }}>
        <Chip
          variant="filled"
          color="secondary"
          label={APP_VERSION}
          size="small"
          sx={{ alignSelf: "flex-end" }}
        />
      </Box>
      <img
        src={HNLNavLogo}
        alt="hats and ladders logo"
        width="90%"
        height="85%"
      />
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  const userDashLink =
    currentUser.role === "climber" && msPlans.length > 0
      ? `/ms/${currentUser.role}/dashboard`
      : `/${currentUser.role}/dashboard`;

  return (
    <Link
      component={RouterLink}
      href={userDashLink}
      sx={{ display: "contents" }}
    >
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

Logo.displayName = "Logo";
export default Logo;
